<ng-container *ngIf="settingsStore.locale$ | async as locale">
    <dsw-footer *ngIf="footerStore.state$ | async as state" [locale]="locale" viessmannLogoUrl="/">
        <div version>
            <span [attr.version]="state.version" data-testid="app-version">{{ 'FOOTER.APP' | translate }} {{ state.appVersion }}</span>
        </div>
        <span version>|</span>
        <span version>{{ 'FOOTER.CALCULATION_API' | translate }} {{ state.calculationApiVersion }}</span>
    </dsw-footer>
</ng-container>
